export const aboutPage = {
  hero: {
    eyebrow: 'D.A. Alexander & Company',
    title: 'Creating beautiful environments since 1978.',
    intro:
      'From residential gardens to developing communities and commercial grounds, our work brings landscape design, installation and property care together.',
    detail: 'Based in Livonia, we serve homes, developments, businesses and HOA communities across southeast Michigan. Tell us about your property and the changes you have in mind, or explore the services that fit.',
    primary: { label: 'Tell us about your property', href: '/contact' },
    secondary: { label: 'Explore our services', href: '/services' },
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/northville-logo-cleaned-20261029.png',
    alt: 'Stone steps and a garden path in a wooded residential landscape.',
  },
  company: {
    title: 'Rooted in landscape experience.',
    paragraphs: [
      'Based in Livonia, D.A. Alexander & Company has provided landscape design, installation and maintenance services since 1978. Our work connects the practical needs of a property with the planting, hardscape and outdoor spaces people enjoy.',
      'Today, residential landscapes and land development lead our services, alongside commercial landscape maintenance and seasonal property care for businesses and homeowners associations.',
    ],
  },
  paths: {
    title: 'Create. Establish. Care.',
    items: [
      {
        title: 'Residential landscapes',
        text: 'Landscape design, renovation, hardscapes and outdoor living.',
        href: '/residential-landscapes',
      },
      {
        title: 'Land development',
        text: 'Planting, ground cover and landscape stabilization for new sites.',
        href: '/land-development',
      },
      {
        title: 'Commercial landscape care',
        text: 'Ongoing grounds maintenance for commercial properties and HOA communities.',
        href: '/commercial-landscape-care',
      },
      {
        title: 'Commercial & seasonal services',
        text: 'Snow and ice management, parking-lot care and construction-site support.',
        href: '/commercial-seasonal-services',
      },
    ],
  },
  recognition: {
    title: 'Experience you can see in the work.',
    proof: ['Since 1978', 'MGIA-recognized residential landscapes', 'Former HBA Subcontractor of the Year'],
    action: { label: 'Explore award-winning projects', href: '/awards' },
  },
  closing: {
    title: 'Let’s talk about your property.',
    text: 'Tell us what you would like to create, improve or care for. We’ll help you find the right place to start.',
    action: { label: 'Start a conversation', href: '/contact' },
  },
};
